export default {
  title: 'light',

  colors: {
    primary: '#C62E65',
    secundary: '#D63AF9',

    background: '#f5f5f5',
    text: '#333'
  },
};
